export const isMobileBreakpoint = () => window.innerWidth < 768;
export const isDesktopBreakpoint = () => window.innerWidth >= 768;
